import React, { useEffect } from "react";

const WidgetPage = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://storage.googleapis.com/micro_app/index.js";
    script.async = true;
    script.type = "module";
    document.body.appendChild(script);

    script.onload = () => {
      console.log("Script loaded in the widget page");
      if (window.MyApp) {
        window.MyApp();
      } else {
        console.error("MyApp is not available");
      }
    };

    script.onerror = () => {
      console.error("Failed to load MyApp script");
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="app">Loading Widget...</div>;
};

export default WidgetPage;
